import { CommonWriteIcon, ReviewGuideImageIcon } from '@web/../assets/icons'

import Clickable from '@web/components/Clickable'
import { gql } from '@web/gql'
import { MoreReviewContent_ReviewGroupFragment } from '@web/gql/graphql'
import { useGoTo } from '@web/hooks/useGoTo'
import nClicks from '@web/libs/nlog/click/codes'
import { ReviewDetailType } from '@web/types'

import styles from './MoreReviewContent.module.scss'

interface Props {
  reviewGroup: MoreReviewContent_ReviewGroupFragment
  type?: ReviewDetailType
  nClickArea?: {
    EDITMORE: string
  }
}

const MoreReviewContent = ({
  reviewGroup,
  type = ReviewDetailType.REVIEW_END,
  nClickArea = nClicks.reviewEnd,
}: Props) => {
  const { goToReviewEditByReviewGroup } = useGoTo()
  const handleClick = () => goToReviewEditByReviewGroup({ reviewGroup, openWindow: true })

  if (type === ReviewDetailType.REVIEW_FEED) {
    return (
      <Clickable onClick={handleClick} className={styles.btn_review} nClickCode={nClickArea.EDITMORE}>
        <CommonWriteIcon className={styles.icon} aria-hidden="true" />이 날 방문 어땠나요? 리뷰를 남겨보세요
      </Clickable>
    )
  }

  return (
    <Clickable onClick={handleClick} className={styles.guide_area} nClickCode={nClickArea.EDITMORE}>
      <ReviewGuideImageIcon className={styles.icon} aria-hidden="true" />
      <p className={styles.txt}>방문 경험을 남겨주세요</p>
    </Clickable>
  )
}

MoreReviewContent.fragments = gql(`
  fragment MoreReviewContent_ReviewGroup on ReviewGroup {
    id
    ...UseGoToReviewEdit_ReviewGroup
  }
`)

export default MoreReviewContent
